export const initialState = {
    language: 'en_GB',
    graphType: 'Height',
    measurementSystem: 'metric',
    dataSet: 'United Kingdom',
};

export const reducer = (state, action) => {
    switch (action.type) {
        case 'OPTIONS_UPDATE':
            return {
                ...state,
                ...action,
            };
        case 'OPTIONS_RESET':
            return {
                ...initialState,
            };
        default:
            return state;
    }
};
